/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import ITiposMovimientos from './entidades/tiposMovimientos';

export default class ModeloTiposMovimientos {
    public consultarTiposMovimientos() {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocio.get('TiposMovimientos/ConsultarListaTiposMovimientos')
        );
    }

    public consultarTiposDocumentosCompuestoFiltro() {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocio.get('TiposMovimientos/ConsultarTiposDocumentosCompuestoFiltro')
        );
    }

    public crearTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocio.post('TiposMovimientos/GuardarTiposMovimientos', tiposMovimientos)
        );
    }

    public editarTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocio.put('TiposMovimientos/EditarTiposMovimientos', tiposMovimientos)
        );
    }

    public eliminarTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocio.delete('TiposMovimientos/EliminarTiposMovimientos', tiposMovimientos)
        );
    }
}
